// Player colors (distinct on the deep-purple ground, readable with dark ink on top)
export const PLAYER_COLORS = [
  "#FF5A36", // adjika
  "#FFC23D", // churchkhela
  "#B8F23A", // tkemali
  "#2ED3E6", // borjomi
  "#FF4FA3", // pomegranate
  "#9B7BFF", // blackberry
  "#FF9A1F", // persimmon
  "#38E09A", // tarragon
  "#5EA8FF", // sky
  "#F2E3C6", // matsoni
  "#E85D75", // rose wine
  "#C9A2FF", // lilac
] as const;

/**
 * Avatars: illustrated 3D stickers in three moods
 * (public/img/avatars/<id>.webp, <id>-happy.webp, <id>-sad.webp) with an emoji fallback.
 * Every avatar has its own voice (`sound`, synthesized in lib/sfx.ts).
 * Keep ids and ORDER stable — the index is stored in rooms and user profiles. Append only.
 */
export const AVATARS: { id: string; emoji: string; sound: string }[] = [
  { id: "khinkali", emoji: "🥟", sound: "boing" },
  { id: "churchkhela", emoji: "🍡", sound: "swish" },
  { id: "pomegranate", emoji: "🍎", sound: "seeds" },
  { id: "grapes", emoji: "🍇", sound: "plinks" },
  { id: "khachapuri", emoji: "🧀", sound: "sizzle" },
  { id: "pepper", emoji: "🌶️", sound: "hot" },
  { id: "kantsi", emoji: "🍷", sound: "clink" },
  { id: "dog", emoji: "🐕", sound: "woof" },
  { id: "cat", emoji: "🐈", sound: "meow" },
  { id: "bear", emoji: "🐻", sound: "growl" },
  { id: "fox", emoji: "🦊", sound: "yip" },
  { id: "owl", emoji: "🦉", sound: "hoot" },
  { id: "sheep", emoji: "🐑", sound: "baa" },
  { id: "tur", emoji: "🐐", sound: "bleat" },
  { id: "tamada", emoji: "🥸", sound: "toast" },
  { id: "spy", emoji: "🕶️", sound: "spy" },
  { id: "car", emoji: "🚗", sound: "car" },
  { id: "rooster", emoji: "🐓", sound: "crow" },
  { id: "cow", emoji: "🐄", sound: "moo" },
];

/** Brand colours per game (candy palette from the 3D logo). */
export const GAME_COLORS = {
  bluff: "#FF3355",
  spy: "#B6F23B",
  match: "#FF4FC8",
  truf: "#29C9FF",
  joker: "#FFC21A",
} as const;
